import saveTask from './saveTask'
import uploadFilesTask from './uploadFilesTask'

export const saveTaskPromise = saveTask
export const uploadFilesTaskPromise = uploadFilesTask
